

export const lightTheme = {
    body: '#fff',
    text: '#073b4c',
    toggleBorder: '#FFF',
    background: '#fff',
    shadow: '2px 2px 10px #073b4c',
    colors: {
        icon: '#666666',
      }
};

export const darkTheme = {
    body: '#073b4c',
    text: '#06d6a0',
    toggleBorder: '#ef476f',
    background: '#073b4c',
    shadow: '2px 2px 10px #ffd166',
    box: '#fff'
};

